<template>
    <div class="d-flex flex-column schema-table">
        <div v-if="!tableOnly" class="d-flex align-center mb-5">
            <v-text-field
                v-model="searchInput"
                class="no-print"
                label="Search"
                hide-details
                dense
                color="primary"
                outlined
                prepend-inner-icon="mdi-magnify"
                @keyup.enter="applySearch" />
            <slot name="add-button">
                <app-icon-button
                    v-if="canAdd"
                    class="ml-4 no-print"
                    color="primary"
                    icon="mdi-plus"
                    @click="add" />
            </slot>
            <schema-excel-export-button
                v-if="!disableExport"
                v-bind="$attrs"
                class="ml-4 no-print"
                :entity-key="entityKey"
                :scope="scope"
                :list-request="listRequest" />
        </div>

        <!-- Status filter buttons -->
        <proposal-status-filter-buttons
            v-if="entityKey === 'proposal'"
            @status-change="onStatusChange" />

        <v-card :class="cardClasses" :elevation="outlined ? 0 : 4">
            <component
                :is="tableComponent"
                :key="entityKey"
                ref="schemaDataTable"
                class="flex-grow-1"
                v-bind="$attrs"
                :entity-key="entityKey"
                :search-text="searchText"
                :scope="scope"
                :readonly="readonly"
                :has-item-page="hasItemPage"
                :edit-disabled="editDisabled"
                :fixed-values="computedFixedValues"
                @list-request="setListRequest"
                @edit="edit">
                <template #extra-actions="{ item }">
                    <slot name="extra-actions" :item="item" />
                </template>
            </component>
        </v-card>
        <schema-form-dialog
            :entity-key="entityKey"
            :scope="scope"
            :value="editedItem"
            :form="form"
            v-bind="$attrs"
            @input="onItemSaved" />
    </div>
</template>
<script>
import tableMixin from "@/features/schemas/mixins/tableMixin";
import ProposalStatusFilterButtons from "@/features/proposals/ProposalStatusFilterButtons.vue";

export default {
    components: {
        ProposalStatusFilterButtons
    },
    mixins:[tableMixin],
    props: {
        fixedValues: {
            type: Object,
            default: null
        }
    },
    types: [
        "proposal"
    ],
    data() {
        return {
            statusFilter: null,
            searchInput: ""
        };
    },
    computed: {
        computedFixedValues() {
            return {
                ...(this.fixedValues || {}),
                ...(this.statusFilter || {})
            };
        }
    },
    methods: {
        applySearch() {
            this.searchText = this.searchInput;
        },
        onStatusChange(status) {
            if (status === null) {
                this.statusFilter = null;
            } else {
                this.statusFilter = {
                    proposalStatus: status
                };
            }
        },
        async onItemSaved(item) {
            const isNew = !this.editedItem?.id;
            await tableMixin.methods.onItemSaved.call(this, item);
            if (isNew && item?.id) {
                await this.$router.push(`/proposal/${item.id}`);
            }
        }
    }
};
</script>
